import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock, ArrowLeft } from "lucide-react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_clinic-booking-86/artifacts/lfwsi76p_Logo_CE_fondoBlanco.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function LoginPage() {
    const handleLogin = () => {
        const redirectUrl = window.location.origin + "/admin";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl
        )}`;
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-5 py-12">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <img
                        src={LOGO_URL}
                        alt="Logo Ciudad Enfermería"
                        className="w-20 h-20 rounded-full object-contain bg-white ring-1 ring-border mx-auto mb-4"
                    />
                    <h1 className="font-heading text-3xl font-medium tracking-tight">
                        Panel administrativo
                    </h1>
                    <p className="text-muted-foreground mt-2">
                        Acceso solo para personal autorizado de Ciudad Enfermería.
                    </p>
                </div>

                <div className="rounded-3xl border border-border bg-card p-8 soft-shadow">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                            <Lock className="h-5 w-5 text-primary" />
                        </div>
                        <div>
                            <p className="font-heading text-base font-medium">
                                Iniciar sesión
                            </p>
                            <p className="text-sm text-muted-foreground">
                                Solo cuentas autorizadas
                            </p>
                        </div>
                    </div>

                    <Button
                        onClick={handleLogin}
                        className="w-full h-12 rounded-2xl bg-foreground text-background hover:bg-foreground/90 hover:-translate-y-0.5 transition-all gap-3"
                        data-testid="login-google-btn"
                    >
                        <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden>
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                        <span className="font-medium">Iniciar sesión con Google</span>
                    </Button>

                    <p className="text-xs text-muted-foreground mt-5 text-center">
                        Al continuar, serás redirigido a Google para autenticarte de forma segura.
                    </p>
                </div>

                <div className="text-center mt-6">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
                        data-testid="login-back-home"
                    >
                        <ArrowLeft className="h-3.5 w-3.5" />
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
}
